import styled from "styled-components";

const EmailContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export default EmailContent;